import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Provider, ProviderType } from '../../models/provider.model';

@Component({
  selector: 'app-search-provider-modal',
  templateUrl: './search-provider-modal.component.html',
  styleUrl: './search-provider-modal.component.scss'
})
export class SearchProviderModalComponent {
@Input() showProviderModal: boolean = false;
@Input() providers: any[] = [];
selectedProviderName: string = '';
selectedProvider?: Provider;
@Output() closeModal = new EventEmitter<void>();
@Output() selectProviderEmitter = new EventEmitter<Provider>();
@Output() addProviderEmitter = new EventEmitter<void>();
@Output() searchProviderEmitter = new EventEmitter<string>();
@Output() acceptProviderEmitter = new EventEmitter<Provider>();

  handleCancelModal() {
    this.closeModal.emit();
  }

  searchProviders(event: any) {
    const search = event.target.value;
    this.searchProviderEmitter.emit(search);
  }

  selectProvider(provider: any) {
    if (!provider) return;
    this.selectedProvider = provider.data;
    this.selectProviderEmitter.emit(provider.data);
  }

  addProvider() {
    this.addProviderEmitter.emit();
  }
  
  acceptProvider() {
    this.acceptProviderEmitter.emit(this.selectedProvider);
    this.closeModal.emit();
  }
}
